<template>
  <div id="app">
  <router-view class='page'/>
  <notifications/>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  },
  computed: {
    logged() {
      return this.$route.name && this.$route.name != 'login'
    }
  }
}
</script>

<style lang="scss">
@import '~normalize.scss/normalize';
@import './assets/scss/base.scss';
@import './assets/fonts/fonts.css';

#app {
  font-family: "Proxima", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #454545;
  background-color: #EFEFEF;
  overflow: hidden;
  min-height: 100%;
  display: flex;
  }

  .notifications {
    width: 100% !important;
    text-align: center;
    background: white;
    .vue-notification{
      background-color: #2266BB;
      border: 1px solid #2266BB;
      margin: 0;
      height: 100%;
      color: black;
      font-size: 14px;
      text-align: center;
      height: 83px;
      padding: 36px 0;
      display: flex;
    }
    .vue-notification.error{
      background-color: #D2144433;
      border: 1px solid #D21444;
    }
    .vue-notification.success{
      background-color: #2266BB33;
      border: 1px solid #2266BB;
    }
    .notification-wrapper {
      height: 100%;
    }
    .notification-content {
      margin: auto;
    }
    
  }
</style>
